import { createActions, createReducer } from 'reduxsauce'

import AdiantamentoSuprimentosService from '../../servicos/DetalhesAdiantamentosSuprimentosService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaFornecedoresInicio: [],
    buscaFornecedoresSucesso: ['fornecedores'],
    buscaFornecedoresErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    resultado: [],
    selecionado: null,
    dataAtualizacaoDados: null,
}

// Ação para busca completa
Creators.buscaFornecedores = filtro => {
    return dispatch => {
        dispatch(Creators.buscaFornecedoresInicio())
        let serv = new AdiantamentoSuprimentosService()
        return serv
            .consultarFornecedores(filtro)
            .then(response => dispatch(Creators.buscaFornecedoresSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaFornecedoresErro(error)))
    }
}

const buscaFornecedoresInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaFornecedoresErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaFornecedoresSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, resultado: action.fornecedores, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_FORNECEDORES_INICIO]: buscaFornecedoresInicio,
    [Types.BUSCA_FORNECEDORES_ERRO]: buscaFornecedoresErro,
    [Types.BUSCA_FORNECEDORES_SUCESSO]: buscaFornecedoresSucesso,
})
